import { render } from "./EditionDashboard.vue?vue&type=template&id=ecdc619e&scoped=true&ts=true"
import script from "./EditionDashboard.vue?vue&type=script&lang=ts"
export * from "./EditionDashboard.vue?vue&type=script&lang=ts"

import "./EditionDashboard.vue?vue&type=style&index=0&id=ecdc619e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecdc619e"]])

export default __exports__